import { DateTime } from 'luxon';
import { dateToDbDateString } from '../../framework/util/convert';
import { InvoiceRowType } from '../model/enums/InvoiceRowType';

export function constructMonthsFromNowString(offset: number): string {
    return dateToDbDateString(
        DateTime.now()
            .plus({
                months: offset,
            })
            .endOf('month')
            .toJSDate(),
    );
}

export const monthlyVehicleContractCostColumns: string[] = [
    InvoiceRowType.CAR_WASH_MONTHLY_PAYMENT,
    InvoiceRowType.DAILY_RENT,
    InvoiceRowType.ELECTRICAL_CHARGING,
    InvoiceRowType.FINANCING_MONTHLY_FEE,
    InvoiceRowType.FINANCING_MONTHLY_MANAGEMENT_FEE,
    InvoiceRowType.FINANCING_MONTHLY_PAYMENT_LEASING,
    InvoiceRowType.FINANCING_MONTHLY_PAYMENT_PART_PAYMENT,
    InvoiceRowType.FINANCING_MONTHLY_SERVICE_BUDGET,
    InvoiceRowType.FUEL_CARD_MONTHLY_PAYMENT,
    InvoiceRowType.IMPORTER_CARE_SUPPORT_MONTHLY_PAYMENT,
    InvoiceRowType.INSURANCE_MONTHLY_PAYMENT,
    InvoiceRowType.MAINTENANCE_MONTHLY_PAYMENT,
    InvoiceRowType.MINILEASING,
    InvoiceRowType.PARKING_BUDGET,
    InvoiceRowType.PERIODIC_INSPECTION_MONTHLY_PAYMENT,
    InvoiceRowType.SMARTFLEET_MONTHLY_FEE,
    InvoiceRowType.SUBSTITUTE_VEHICLE_MONTHLY_PAYMENT,
    InvoiceRowType.TIRE_RENEWAL_MONTHLY_PAYMENT,
    InvoiceRowType.TIRE_STORAGE_MONTHLY_PAYMENT,
    InvoiceRowType.VEHICLE_TAX_MONTHLY_PAYMENT,
    InvoiceRowType.VEHICLE_TRACKING_MONTHLY_PAYMENT,
    InvoiceRowType.UNSPECIFIED,
];
